import TagManager from 'react-gtm-module';

class CustomTagManager {
  static pushEvent(eventName, data = {}) {
    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        ...data,
      },
    });
  }

  static QR_Download_Page_View() {
    this.pushEvent('QR_Download_Page_View');
  }

  static QR_Download_Page_View_Expired() {
    this.pushEvent('QR_Download_Page_View_Expired');
  }

  static QR_Download_Page_Download_Photo_Clicked() {
    this.pushEvent('QR_Download_Page_Download_Photo_Clicked');
  }

  static QR_Download_Page_Download_Video_Clicked() {
    this.pushEvent('QR_Download_Page_Download_Video_Clicked');
  }

  static QR_Download_Page_Download_Timelapse_Clicked() {
    this.pushEvent('QR_Download_Page_Download_Timelapse_Clicked');
  }

  static QR_Download_Page_Long_Press_On_Photo() {
    this.pushEvent('QR_Download_Page_Long_Press_On_Photo');
  }

  static QR_Download_Page_Banner_Ranking_Clicked() {
    this.pushEvent('QR_Download_Page_Banner_Ranking_Clicked');
  }

  static QR_Download_Page_Popup_Ranking() {
    this.pushEvent('QR_Download_Page_Popup_Ranking');
  }

  static QR_Download_Page_Popup_Ranking_Clicked() {
    this.pushEvent('QR_Download_Page_Popup_Ranking_Clicked');
  }
}

export default CustomTagManager;
